import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import '../sign-on/styles/SignOn.scss'

import { passwordValidate } from 'util/services/Validator'
import { Recovery as RecoveryOpts } from '../redux/types'
import { maskCNPJ, maskCPF, maskPhone } from 'util/masks'
import { recoveryPassword, recoveryPre, recoveryRequest, recoveryVerify } from 'panel/user/redux/actions'

const initialFormPre = { value: '', email: '', phone: '', docNumber: '' }

const Recovery: React.FC = () => {
  const dispatch = useDispatch()

  // Forms
  const [step, setStep] = useState<'START'|'PRE'|'SEND'|'PASSWORD'|'FINISH'>('START')
  const [isFetching, setFetching] = useState(false)
  const [formPre, setFormPre] = useState(initialFormPre)
  const [selected, setSelected] = useState(-1)
  const [selectedValue, setSelectedValue] = useState('')
  const [code, setCode] = useState('')
  const [formPass, setFormPass] = useState({ newPassword: '', confirmNewPassword: '' })

  // States
  const [recovery, setRecovery] = useState<RecoveryOpts>()

  // Recovery
  const types: any = { email: 'E-mail', phone: 'Telefone' }
  const selectedType = recovery?.recovery[selected]?.type
  const selectedRecovery = recovery?.recovery[selected]

  const validation = passwordValidate(formPass.newPassword, formPass.confirmNewPassword)

  function maskValue (value: string): string {
    const replaced = value.replace(/[\D]/g, '')
    const isCPF = /[\d]{3,11}/g.test(replaced)
    const isCNPJ = /[\d]{12,14}/g.test(replaced)

    return isCNPJ ? maskCNPJ(value) : (isCPF ? maskCPF(value) : value)
  }

  async function handlePre (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    setFetching(true)
    await recoveryPre(formPre)(dispatch).then(res => {
      if (res?.status === 'success' && res?.data) {
        setRecovery(res.data)
        if (res.data.isSend) {
          setStep('SEND')
          setSelected(0)
        } else {
          setStep('PRE')
        }
      }
    })
    setFetching(false)
  }

  async function handleRequest (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    if (selectedRecovery && selectedType) {
      const type = selectedRecovery.type
      const value = selectedRecovery.value !== formPre[selectedType] ? selectedValue : selectedRecovery.value

      if (value) {
        setFetching(true)
        await recoveryRequest({ type, value })(dispatch).then(res => {
          if (res?.status === 'success') {
            setStep('SEND')
          }
        })
        setFetching(false)
      } else {
        alert('Preencha o formulário corretamente')
      }
    }
  }

  async function handleVerify (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    if (code) {
      setFetching(true)
      await recoveryVerify({ code })(dispatch).then(res => {
        if (res?.status === 'success') {
          setStep('PASSWORD')
        }
      })
      setFetching(false)
    } else {
      alert('Código não informado')
    }
  }

  async function handlePassword (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    const newPassword = formPass.newPassword

    if (code && newPassword) {
      if (newPassword && !validation.isValid) {
        alert(validation.warnings[0] || 'Senha Inválida')
      } else {
        setFetching(true)
        await recoveryPassword({ code, newPassword })(dispatch).then(res => {
          if (res?.status === 'success') {
            setStep('FINISH')
          }
        })
        setFetching(false)
      }
    } else {
      alert('Formulário inválido')
    }
  }

  const logo = `${process.env.PUBLIC_URL}/img/logo.png`
  const logoWhite = `${process.env.PUBLIC_URL}/img/logo-white.png`

  return (
    <div className="row sign-on">
      <div className="row">
        <div className="row side-left">
          <img width={350} className="margin-top-16" src={logoWhite} alt="Logo" />
        </div>
        <div className="row side-right">
          <div className="row justify-start align-start">
            <img className="padding-16 margin-tb-16 hidden-desk" src={logo} alt="Logo" />
            <h1>Recupere sua conta</h1>

            <div className="row padding-16 margin-top-16 border-radius bordered">
              {
                step === 'START' &&
                <form onSubmit={handlePre}>
                  <div className="form-control">
                    <label>Informe seu e-mail, CPF/CNPJ ou Telefone</label>
                    <input
                      type="text"
                      value={formPre.value}
                      onChange={(e): void => {
                        const docNumber = maskValue(e.target.value)
                        setFormPre({
                          ...formPre,
                          value: e.target.value,
                          email: e.target.value,
                          phone: maskPhone(e.target.value),
                          docNumber
                        })
                      }}
                      required={true}
                    />
                  </div>
                  <button className="button primary col-12 margin-top-16" disabled={isFetching}>
                    Avançar <i className="fa fa-angle-right" style={{ marginBottom: -2 }} />
                  </button>
                </form>
              }
              {
                !!(step === 'PRE' && recovery) &&
                <form onSubmit={handleRequest}>
                  <h2>{ recovery.name }</h2>
                  <p>Selecione a forma de recuperação</p>

                  <div className="row margin-top-16">
                    {
                      recovery.recovery.map((item, i) => {
                        return (
                          <div
                            key={i}
                            className={`row tile ${selected === i ? 'active' : ''}`}
                            onClick={(): void => setSelected(selected === i ? -1 : i)}
                          >
                            { types[item.type] }:&nbsp;<b>{ item.value }</b>
                          </div>
                        )
                      })
                    }
                  </div>

                  {
                    !!(selected > -1 && selectedType && selectedRecovery) &&
                    <div className="row margin-top-16">
                      {
                        selectedRecovery.value !== formPre[selectedType] &&
                        <div className="form-control">
                          <label>Preencha o { types[selectedType] }</label>
                          <input
                            type="text"
                            value={selectedValue}
                            onChange={(e): void => {
                              const isPhone = selectedRecovery.type === 'phone'
                              setSelectedValue(isPhone ? maskPhone(e.target.value) : e.target.value)
                            }}
                          />
                        </div>
                      }
                      <button className="primary col-12 margin-top-8">
                        Solicitar Código <i className="fa fa-angle-right" style={{ marginBottom: -2 }} />
                      </button>
                    </div>
                  }
                </form>
              }
              {
                step === 'SEND' && recovery &&
                <form onSubmit={handleVerify}>
                  <h2>{ recovery.name }</h2>
                  <p>
                    Código enviado para:&nbsp;<b>{ recovery.recovery[0]?.value }</b>
                  </p>

                  <div className="form-control">
                    <label>Informe o Código Recebido</label>
                    <input
                      type="text"
                      value={code}
                      onChange={(e): void => { setCode(e.target.value.toUpperCase()) }}
                    />
                  </div>

                  <button className="primary col-12 margin-top-8">
                    Validar Código <i className="fa fa-angle-right" style={{ marginBottom: -2 }} />
                  </button>
                </form>
              }
              {
                step === 'PASSWORD' && recovery &&
                <form onSubmit={handlePassword}>
                  <h2>{ recovery.name }</h2>
                  <p>Código Validado! Crie uma nova senha</p>

                  <div className="form-control">
                    <label>Nova Senha</label>
                    <input
                      type="password"
                      value={formPass.newPassword}
                      onChange={(e): void => { setFormPass({ ...formPass, newPassword: e.target.value }) }}
                    />
                  </div>
                  <div className="form-control">
                    <label>Confirme a Nova Senha</label>
                    <input
                      type="password"
                      value={formPass.confirmNewPassword}
                      onChange={(e): void => { setFormPass({ ...formPass, confirmNewPassword: e.target.value }) }}
                    />
                  </div>

                  <p className="col-12 text-center">
                    {validation.warnings?.[0] || <>&nbsp;</>}
                  </p>

                  <button className="primary col-12 margin-top-8">
                    Criar nova senha
                  </button>
                </form>
              }
              {
                step === 'FINISH' &&
                <form onSubmit={handlePassword}>

                  <h1 className="text-center" style={{ color: 'green' }}><i className="fa fa-check-circle fa-4x" /></h1>
                  <h2 className="text-center">Sua senha foi atualizada!</h2>
                  <p className="text-center">Utilize a senha que criou para entrar</p>

                  <NavLink to="/sign-in" className="button primary col-12 margin-top-16">
                    Voltar ao Login
                  </NavLink>
                </form>
              }
            </div>

            {/* Buttons */}
            <NavLink to="/sign-in" className="button col-12 margin-top-16">
              Já possui conta? Fazer login.
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Recovery
